import React from "react";

import { DEFAULT_LOCALE } from "./locale";
import { getTranslator } from "./translate";

// The value is the translate function. Without a provider it is English, so
// the internal screens that share the application steps stay as they were.
const LocaleContext = React.createContext(getTranslator(DEFAULT_LOCALE));

export default LocaleContext;
